import React from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import Head from '../admin/layouts/Head';

const NotFoundPage = () => {
  return (
    <>
      <Head
        title={'Page Not Found'}
        isIndex={false} />

      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Row className="text-center">
          <Col>
            <div className="error-content">
              <h1 className="display-1 text-danger">
                <i className="bi bi-exclamation-circle"></i> 404
              </h1>
              <p className="lead text-muted">Oops! The page you're looking for does not exist.</p>
              <Button
                variant="success"
                size="lg"
                href="/"
                className="mt-4"
              >
                <i className="bi bi-house-door"></i> Back to Home
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NotFoundPage;
